<template>
  <div>
    <v-container class="pl-10 pr-10">
      <p class="display-1 mt-7">정품 인증 코드 생성</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        정품 인증 코드를 부착할 상품을 조회하여 코드를 생성합니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        상품을 조회하여 원하는 수량을 기입하면 보안화된 인증 코드를 만들어줍니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        생성된 정품 인증 상품은 인쇄하여 상품에 부착할수가 있습니다.
      </p>

      <v-tabs class="mt-10">
        <!--
          상품조회 contents 영역
        -->
        <v-tab class="title">상품조회(신규 생성)</v-tab>
        <v-tab-item>
          <SearchCreateAuthCode :duration.sync="duration"></SearchCreateAuthCode>
        </v-tab-item>

        <!--
          엑셀업로드 contents 영역
        -->

        <v-tab class="title" :duration.sync="duration">엑셀업로드(신규 생성)</v-tab>
        <v-tab-item>
          <ExcelCreateAuthCode></ExcelCreateAuthCode>
        </v-tab-item>

        <!--
          엑셀업로드 contents 영역
        -->

        <v-tab class="title" :duration.sync="duration">엑셀업로드(기존 사용 코드 매칭)</v-tab>
        <v-tab-item>
          <ExcelMatchCreateAuthCode></ExcelMatchCreateAuthCode>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </div>
</template>
<style scoped>
.disabledTab {
  font-size: 1.25rem !important;
  font-weight: 500;
  display: flex;
  align-items: center;
  cursor: default;
  color: #bababa;
}
</style>
<script>
import CommonMixin from "@/mixins/CommonMixin.js";
import SearchCreateAuthCode from "@/components/shoplus_authservice/authcode/SearchCreateAuthCode.vue";
import ExcelCreateAuthCode from "@/components/shoplus_authservice/authcode/ExcelCreateAuthCode.vue";
import ExcelMatchCreateAuthCode from "@/components/shoplus_authservice/authcode/ExcelMatchCreateAuthCode.vue";
import { AUTH_SERVICE } from "@/datas/authservice";
import M from "@/libs/mapping.js";

export default {
  data: () => ({
    AUTH_SERVICE,
    duration: {
      cert_duration_type: AUTH_SERVICE.ACTIVATED,
      cert_duration: "1d",
      days: 1,
      days_type: "d",
    },
  }),
  components: {
    SearchCreateAuthCode,
    ExcelCreateAuthCode,
    ExcelMatchCreateAuthCode,
  },
  mixins: [CommonMixin],
  created: async function() {
    /**
     * 설정 데이터 가져오기
     */
    await this.getDuration();
  },
  methods: {
    /**
     * 데이터 가져오기
     */
    getDuration: async function() {
      let data = await M.api(M.entry("/get/duration"));
      if (data) {
        this.duration.cert_duration_type = data.duration_type;
        this.duration.cert_duration = data.duration;
        this.duration.days = data.duration.replace(/[a-z]/gi, "");
        this.duration.days_type = data.duration.replace(/[0-9]/g, "");
      }
    },
    checkVersionAlret: function() {
      let msg = "해당 메뉴는 '플러스 버전' 에서 사용이 가능합니다.</br>[결제관리] 메뉴에서 버전을 변경/결제하여 사용해주세요.";
      this.alertShow(msg);
    },
  },
};
</script>
